import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useEventReporter } from '~/event-reporter';
import { useClientView } from '~/hooks/useClientView';
import { useStoreActions } from '~/store/store-context';
import { addToAnotherClientModalConfig, editContactModalConfig } from '../modals/legacyContactModals';
export function useLegacyContactActions(param) {
    let { contacts, refresh } = param;
    const { showModal } = useOverlayContext();
    const { logBI } = useStoreActions();
    const { reportToGtm, reportToAppcues } = useEventReporter();
    const { startClientView } = useClientView();
    const [registerSearchBoxHotkey, setRegisterSearchBoxHotkey] = useState(true);
    const editWithinClient = async (contact, clientId)=>{
        await showModal(editContactModalConfig({
            contact,
            clientId
        }));
        await refresh();
    };
    const reportContactOpened = (contact)=>{
        logBI(11600, {
            contact: contact.toJSON()
        });
        reportToGtm('button-click', 'contacts-table-view-contact');
        reportToAppcues('button-click', 'contacts-table-view-contact');
    };
    const whileHotkeyReleased = async (action)=>{
        setRegisterSearchBoxHotkey(false);
        try {
            await action();
        } finally{
            setRegisterSearchBoxHotkey(true);
        }
    };
    const openContact = async (contact)=>{
        const clientId = contact.customerId();
        if (clientId == null) return;
        await editWithinClient(contact, clientId);
    };
    return {
        registerSearchBoxHotkey,
        openContactModal: (contact)=>{
            reportContactOpened(contact);
            return whileHotkeyReleased(()=>openContact(contact));
        },
        openAddToAnotherClientModal: (contact)=>whileHotkeyReleased(async ()=>{
                await showModal(addToAnotherClientModalConfig({
                    contact,
                    contacts
                }));
                await refresh();
            }),
        startClientView: (contact)=>{
            var _contact_userId;
            const clientId = contact.customerId();
            if (clientId == null) return;
            startClientView(clientId, (_contact_userId = contact.userId()) !== null && _contact_userId !== void 0 ? _contact_userId : undefined);
        }
    };
}
